import request from '@/utils/request'

// 查询考勤规则列表
export function listAttendance(query) {
  return request({
    url: '/system/attendance/list',
    method: 'get',
    params: query,
  })
}

// 查询考勤规则分页
export function pageAttendance(query) {
  return request({
    url: '/system/attendance/page',
    method: 'get',
    params: query,
  })
}

// 查询考勤规则详细
export function getAttendance(data) {
  return request({
    url: '/system/attendance/detail',
    method: 'get',
    params: data,
  })
}

// 新增考勤规则
export function addAttendance(data) {
  return request({
    url: '/system/attendance/add',
    method: 'post',
    data: data,
  })
}

// 修改考勤规则
export function updateAttendance(data) {
  return request({
    url: '/system/attendance/edit',
    method: 'post',
    data: data,
  })
}

// 删除考勤规则
export function delAttendance(data) {
  return request({
    url: '/system/attendance/delete',
    method: 'post',
    data: data,
  })
}

// 导入考勤规则数据
export function importData(data) {
  return request({
    url: '/system/attendance/importData',
    method: 'post',
    data: data,
  })
}

// 下载导入模板
export function importTemplate() {
  return request({
    url: '/system/attendance/importTemplate',
    method: 'post',
    responseType: 'blob',
  })
}

// 分页查询未排班人员
export function listUnassignedEmployees(query) {
  return request({
    url: '/system/attendance/unassignedEmployees',
    method: 'get',
    params: query,
  })
}

// 将未排班人员分配到当前考勤规则
export function assignEmployees(data) {
  return request({
    url: '/system/attendance/assignEmployees',
    method: 'post',
    data,
  })
}

// 将人员从当前考勤规则中移除
export function unassignEmployees(data) {
  return request({
    url: '/system/attendance/unassignEmployees',
    method: 'post',
    data,
  })
}
